import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CDS_POPUP_DATA } from '@cds/ng-web-components/popup';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

type ContinuePopupData = {
  title: string;
  message: string;
  cancelButtonName: string;
  continueButtonName: string;
  buttonSize?: CdsButtonConfig['size'];
  preserveTopSpacing?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeFn: any;
};

@Component({
  selector: 'app-continue-popup',
  templateUrl: './continue-popup.component.html',
  styleUrls: ['./continue-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, CdsPopupModule, CdsButtonModule, CdsLanguageModule],
})
export class ContinuePopupComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<ContinuePopupComponent>>(MatDialogRef);
  data = inject<ContinuePopupData>(CDS_POPUP_DATA);

  readonly buttonSize: CdsButtonConfig['size'] = this.data.buttonSize ?? 'sm';
  readonly disagreeButtonConfig: CdsButtonConfig = { size: this.buttonSize, style: 'secondary' };
  readonly agreeButtonConfig: CdsButtonConfig = { size: this.buttonSize };

  get shouldCompactWithoutTitle(): boolean {
    return !this.hasTitle && this.data.preserveTopSpacing !== true;
  }

  ngOnInit(): void {}

  get hasTitle(): boolean {
    const title = this.data?.title;
    return typeof title === 'string' && title.trim().length > 0;
  }

  agree() {
    this.dialogRef.close({ agree: true });
  }
  close() {
    this.dialogRef.close({ agree: false });
    if (this.data.closeFn && typeof this.data.closeFn === 'function') {
      this.data.closeFn();
    }
  }
}
